/* eslint react/prop-types: 0 */
import React from 'react';

import { Route, Switch } from 'react-router-dom';

import SystemSettings from './components/system-settings/SystemSettings';
import ArticleList from './components/articles/ArticleList';
import Article from './components/articles/Article';
import TVShowApp from './components/tvshow/TVShowApp';

import Person from './components/Person';
import PeopleList from './components/PeopleList';
import TVShow from './components/tvshow/TVShow';
// Topics
import TopicsApp from './components/topics/TopicsApp';
import TopicEditor from './components/topics/TopicEditor';
import CategoriesApp from './components/categories/CategoriesApp';
import CategoryEditor from './components/categories/CategoryEditor';
// Epg
import Epg from './components/epg/Epg';
import EpgItem from './components/epg/EpgItem';
import MediaGalleryList from './components/media/MediaGalleryList';
// Stream
import StreamList from './components/streams/StreamList';
import Stream from './components/streams/Stream';

import StatsLoader from './components/stats/StatsLoader';
// query
import {
	articleQuery,
	articlesListQuery,
	topicsQuery,
	homeQuery,
	topicQuery,
	categoriesQuery,
	blocksQuery,
	categoryQuery,
	tvshowQuery,
	tvshowsQuery,
	peopleQuery,
	usersQuery,
	userQuery,
	personQuery,
	epgItemQuery,
	epgQuery,
	streamListQuery,
	streamQuery,
	mediaFilesListQuery,
	mediaFilesBackgroundQuery,
	mainPageQuery,
	blockAddFormQuery,
	blockEditFormQuery,
	infoStringQuery,
	infoStringEditFormQuery,
} from './queries';
// background
import Background from './components/background/Background';

import { sectionPath } from './lib/config';
// main page
import Main from './components/main/Main';
import UserEdit from './components/users/UserEdit';
import { UserCreate } from './components/users/UserCreate';
import UserList from './components/users/UserList';
import VocabularyList from './components/vocabulary/vocabulary-list';
import { VocabularyCreate } from './components/vocabulary/vocabulary-create';
import VocabularyEdit from './components/vocabulary/vocabulary-edit';

import HomeContainer from './components/home/home';
import BlockList from './components/blocks/BlockList';
import InfoStringList from './components/info-strings/InfoStringList';
import { BlockCreate } from './components/blocks/BlockCreate';
import BlockEdit from './components/blocks/BlockEdit';
import { InfoStringCreate } from './components/info-strings/InfoStringCreate';
import InfoStringEdit from './components/info-strings/InfoStringEdit';
import { WrappedRoute } from './util/wraped-route';
import {
	configurableBlockListQuery,
	configurableBlockAddQuery,
	configurableBlockEditQuery,
} from './components/configurable-blocks/configurable-block-pages';
import { ConfigurableBlockCreate } from './components/configurable-blocks/ConfigurableBlockCreate';
import ConfigurableBlockEdit from './components/configurable-blocks/ConfigurableBlockEdit';
import ConfigurableBlockList from './components/configurable-blocks/ConfigurableBlockList';

import { vocabularyEditQuery, vocabularyListQuery } from './components/vocabulary/vocabulary-page.queries';

const homeBlockSlug = 'home';

const AppRoutes = () => (
	<Switch>
		<WrappedRoute
			path="/articles/:section/:id"
			query={articleQuery}
			component={Article}
			variables={params => ({
				...params,
				blockSlug: homeBlockSlug,
			})}
		/>
		<WrappedRoute path="/home" query={homeQuery} component={HomeContainer} />
		<WrappedRoute path="/system-settings" component={SystemSettings} />
		<WrappedRoute path="/info-strings/new" query={blockAddFormQuery} component={InfoStringCreate} />
		<WrappedRoute path="/info-strings/:id" query={infoStringEditFormQuery} component={InfoStringEdit} />
		<WrappedRoute
			path="/info-strings"
			query={infoStringQuery}
			component={InfoStringList}
			variables={params => ({
				...params,
				blockSlug: homeBlockSlug,
			})}
		/>

		<WrappedRoute path="/configurable-blocks/new" query={configurableBlockAddQuery} component={ConfigurableBlockCreate} />
		<WrappedRoute path="/configurable-blocks/:id" query={configurableBlockEditQuery} component={ConfigurableBlockEdit} />
		<WrappedRoute path="/configurable-blocks" query={configurableBlockListQuery} component={ConfigurableBlockList} />

		<WrappedRoute path="/blocks/new" query={blockAddFormQuery} component={BlockCreate} />
		<WrappedRoute path="/blocks/:id" query={blockEditFormQuery} component={BlockEdit} />
		<WrappedRoute path="/blocks" query={blocksQuery} component={BlockList} />
		<WrappedRoute
			path="/articles/:section"
			query={articlesListQuery}
			component={ArticleList}
			variables={params => ({
				...params,
				states: ['available', 'draft'],
				blockSlug: homeBlockSlug,
				page: window.location.hash ? parseInt(window.location.hash.replace('#', ''), 10) : 1,
			})}
		/>

		<WrappedRoute path="/topic/:id" query={topicQuery} component={TopicEditor} />
		<WrappedRoute path="/topics" query={topicsQuery} component={TopicsApp} variables={() => ({ section: sectionPath.news })} />
		<WrappedRoute
			path="/categories/:section"
			query={categoriesQuery}
			component={CategoriesApp}
			variables={params => {
				return { section: params.section };
			}}
		/>
		<WrappedRoute path="/category/:id" query={categoryQuery} component={CategoryEditor} />
		<WrappedRoute path="/shows/:id" component={TVShow} query={tvshowQuery} variables={params => ({ ...params, section: sectionPath.rubricTv })} />
		<WrappedRoute
			path="/shows"
			query={tvshowsQuery}
			component={TVShowApp}
			variables={() => ({
				states: ['available', 'archive', 'deleted'],
				page: 1,
			})}
		/>

		<WrappedRoute path="/people" component={PeopleList} query={peopleQuery} />

		<WrappedRoute path="/vocabulary/add" component={VocabularyCreate} />
		<WrappedRoute path="/vocabulary/:id" component={VocabularyEdit} query={vocabularyEditQuery} />
		<WrappedRoute path="/vocabulary" component={VocabularyList} query={vocabularyListQuery} />

		<WrappedRoute path="/users/new" component={UserCreate} />
		<WrappedRoute path="/users/:id" component={UserEdit} query={userQuery} />
		<WrappedRoute
			path="/users"
			component={UserList}
			query={usersQuery}
			variables={params => ({
				...params,
				sortBy: 'name',
				sortDirection: 'asc',
			})}
		/>
		<WrappedRoute path="/new_person/:personType" component={Person} query={personQuery} variables={params => ({ ...params, id: 'new' })} />
		<WrappedRoute path="/person/:id" component={Person} query={personQuery} />
		<WrappedRoute path="/epg/:id" component={EpgItem} query={epgItemQuery} />
		<WrappedRoute
			path="/epg"
			query={epgQuery}
			component={Epg}
			variables={() => ({
				currentDate: window.location.hash ? window.location.hash.replace('#', '') : new Date().toISOString(),
			})}
		/>

		<WrappedRoute
			path="/streams"
			query={streamListQuery}
			component={StreamList}
			variables={() => ({
				states: ['published', 'draft', 'on_air', 'finished'],
				page: window.location.hash ? parseInt(window.location.hash.replace('#', ''), 10) : 1,
			})}
		/>
		<WrappedRoute path="/stream/:id" component={Stream} query={streamQuery} variables={params => ({ ...params, type: 'live' })} />

		<WrappedRoute
			path="/video"
			query={mediaFilesListQuery}
			component={MediaGalleryList}
			variables={() => ({
				types: ['video'],
				states: ['available'],
				page: window.location.hash ? parseInt(window.location.hash.replace('#', ''), 10) : 1,
				sort: 'dateDesc',
				searchText: null,
				show: null,
				topic: null,
			})}
		/>

		<WrappedRoute
			path="/image"
			query={mediaFilesListQuery}
			component={MediaGalleryList}
			variables={() => ({
				types: ['image'],
				states: ['available'],
				page: window.location.hash ? parseInt(window.location.hash.replace('#', ''), 10) : 1,
				sort: 'dateDesc',
				searchText: null,
				show: null,
				topic: null,
			})}
		/>

		<WrappedRoute
			path="/background"
			query={mediaFilesBackgroundQuery}
			component={Background}
			variables={() => ({
				type: 'wallpaper',
				states: ['available'],
				page: 1,
			})}
		/>

		<Route path="/stats/:userId/:page?" component={StatsLoader} />
		<Route path="/stats" component={StatsLoader} />

		<WrappedRoute
			path="/"
			component={Main}
			query={mainPageQuery}
			variables={params => ({
				...params,
				states: ['available', 'draft'],
				page: window.location.hash ? parseInt(window.location.hash.replace('#', ''), 10) : 1,
			})}
		/>
	</Switch>
);

export default AppRoutes;



// WEBPACK FOOTER //
// src/routes.js